/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */
import { Classes } from "@blueprintjs/core";
var NS = Classes.getClassNamespace();
export var MULTISELECT = NS + "-multi-select";
export var MULTISELECT_POPOVER = MULTISELECT + "-popover";
export var OMNIBAR = NS + "-omnibar";
export var OMNIBAR_OVERLAY = OMNIBAR + "-overlay";
export var SELECT = NS + "-select";
export var SELECT_POPOVER = SELECT + "-popover";
//# sourceMappingURL=classes.js.map